import {useContext} from 'react'
import {SpinnerStatusContext} from "../context/SpinnerStatusContextProvider";

export function useSpinnerStatusContext()
{
    const context = useContext(SpinnerStatusContext);

    if (!context) {
        throw new Error(
            "useSpinnerStatusContext must be used within the scope of SpinnerStatusContextProvider"
        );
    }

    return context;
}